<script setup lang="ts">
import type { SuggestionsProps } from "./Suggestions.props"
import type { ButtonProps } from "~/components/Utils/Button.props"

const props = withDefaults(defineProps<SuggestionsProps>(), {
  paddingTop: true,
  ellipsis: true
})

const emit =
  defineEmits<{
    (e: "click", item: ButtonProps): void
  }>()
</script>

<template>
  <div class="search-suggestions" :class="{ 'pt-4 md:pt-6': props.paddingTop }">
    <p v-if="title" class="beaver-bold text-green-main mb-2">
      {{ title }}
    </p>

    <div class="-mx-4 md:mx-0 md:grid md:grid-cols-1">
      <div
        class="
          inline-block
          max-w-full
          border-r
          last:border-0
          md:block
          md:border-0
        "
        v-for="item in suggestions"
      >
        <UtilsButton
          class="transform-gpu drop-shadow-01"
          :key="item.text"
          :to="item.path"
          :ellipsis="ellipsis"
          :fluid="true"
          theme="link-black"
          custom-classes="beaver-medium text-left inline-block px-4 md:px-0 py-0"
          v-bind="item"
          @click="emit('click', item)"
        />
      </div>
    </div>
  </div>
</template>
